export const TIPS_FOR_VIDEO = [
  'Speak for at least 15 seconds',
  'Answer with as much detail as possible',
  'Speak with your head and shoulders in the frame',
  'Avoid background noise and dim lighting',
]; // later on this will be deleted and come directly on the question data

export const CAMERA_CONTAINER_WIDTH = 477;
export const MIN_RECORD_TIME = 15; // in seconds
export const MAX_RECORD_TIME = 2 * 60; // in seconds

export const DISQUALIFYING_PERMISSIONS = ['unsupported', 'denied'];

export const MIME_TYPES = [
  'video/webm; codecs=vp9',
  'video/webm; codecs=vp9,opus',
  'video/webm; codecs=vp8,opus',
  'video/webm; codecs=vp8',
  'video/webm',
  'video/mp4; codecs=h264,aac',
  'video/mp4; codecs=h264',
  'video/mp4',
  'video/mov; codecs=h264,aac',
  'video/mov; codecs=h264',
  'video/mov',
];

export const extensionMap: { [mime: string]: string } = {
  'video/webm; codecs=vp9': 'webm',
  'video/webm; codecs=vp9,opus': 'webm',
  'video/webm; codecs=vp8,opus': 'webm',
  'video/webm; codecs=vp8': 'webm',
  'video/webm': 'webm',
  'video/mp4; codecs=h264,aac': 'mp4',
  'video/mp4; codecs=h264': 'mp4',
  'video/mp4': 'mp4',
  'video/mov; codecs=h264,aac': 'mov',
  'video/mov; codecs=h264': 'mov',
  'video/mov': 'mov',
};
